import { WORKFLOWS } from '@src/graphql/queries/workflow';
import { useFetchItems } from 'pe-core-frontend';
export const useWorkflows = ({ clientId }) => {
    const { items, loading, error } = useFetchItems({
        fetchQuery: WORKFLOWS,
        spec: { clientId },
        dataProp: 'workflows',
    });
    return { workflows: items || [], loading, error };
};
